import React from 'react';

export default function BreakdownChart({ gross, net, tax }) {
  const total = gross || 1; // Prevent division by zero
  const netPct = ((net - tax) / total) * 100;
  const taxPct = (tax / total) * 100;
  const chargesPct = ((gross - net) / total) * 100;

  return (
    <div className="mt-8">
      <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">
        Répartition du salaire brut
      </h4>
      <div className="w-full h-3 flex rounded-full overflow-hidden bg-slate-100 shadow-inner">
        <div 
          style={{ width: `${netPct}%` }} 
          className="bg-emerald-500 transition-all duration-500 ease-out" 
          title="Net dans la poche"
        />
        <div 
          style={{ width: `${taxPct}%` }} 
          className="bg-amber-400 transition-all duration-500 ease-out border-l border-white/20" 
          title="Impôt sur le revenu"
        />
        <div 
          style={{ width: `${chargesPct}%` }} 
          className="bg-slate-300 transition-all duration-500 ease-out border-l border-white/20" 
          title="Charges sociales"
        />
      </div>
      
      <div className="flex justify-between mt-3 text-xs font-medium">
        <div className="flex items-center gap-1.5 text-slate-600">
          <div className="w-2 h-2 rounded-full bg-emerald-500" />
          Net final ({netPct.toFixed(0)}%)
        </div>
        {tax > 0 && (
          <div className="flex items-center gap-1.5 text-slate-600">
            <div className="w-2 h-2 rounded-full bg-amber-400" />
            Impôts ({taxPct.toFixed(0)}%)
          </div>
        )}
        <div className="flex items-center gap-1.5 text-slate-600">
          <div className="w-2 h-2 rounded-full bg-slate-300" />
          Charges ({chargesPct.toFixed(0)}%)
        </div>
      </div>
    </div>
  );
}